import { assertUnreachable } from "./assertUnreachable";
import { isNullish } from "./isNullish";

type DivByZeroResolution = "coerceToZero" | "throwError";

export function guardDivByZero(a: number, b: number, resolution: DivByZeroResolution = "coerceToZero"): number {
  if (b === 0) {
    switch (resolution) {
      case "coerceToZero":
        return 0;
      case "throwError":
        throw new Error(`Division by zero! ${a} / ${b}`);
      default:
        assertUnreachable(resolution);
    }
  }

  return a / b;
}

/**
 * Returns true if the provided value is a number, false otherwise
 *
 * @param val - The value to check
 */
export function isNumber(val: any): val is number {
  return !isNaN(parseFloat(val)) && isFinite(val);
}

/** True when a nullable numeric field was set (including `0`). */
export function isNumberDefined(value: number | null | undefined): value is number {
  return !isNullish(value);
}

export function floatRound(val: number, significantDigits: number = 8): number {
  return Math.round(val * Math.pow(10, significantDigits)) / Math.pow(10, significantDigits);
}

export function roundToDecimalFactor(value: number, factor: number): number {
  return Math.round(value * factor) / factor;
}
